<pr-tag-list
  [tags]="patientTags$ | async"
  (tagAdded)="addTag($event)"
 />
